import { useMemo } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Landing from "./pages/Landing";
import ToolDetail from "./pages/ToolDetail";
import Resources from "./pages/Resources";
import ResourceDetail from "./pages/ResourceDetail";
import Favorites from "./pages/Favorites";
import RequireActive from "./components/RequireActive";
import Settings from "./pages/Settings";
import Unlock from "./pages/Unlock";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import UpdatePassword from "./pages/UpdatePassword";
import NotFound from "./pages/NotFound";
import AdminLogos from "./pages/AdminLogos";
import AdminTools from "./pages/AdminTools";
import AdminToolsCleaner from "./pages/AdminToolsCleaner";
import AdminJobBoards from "./pages/AdminJobBoards";
import JobBoards from "./pages/JobBoards";

const App = () => {
  const queryClient = useMemo(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        retry: 1,
      },
    },
  }), []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tools" element={<RequireActive><Index /></RequireActive>} />
            <Route path="/tool/:slug" element={<RequireActive><ToolDetail /></RequireActive>} />
            <Route path="/resources" element={<RequireActive><Resources /></RequireActive>} />
            <Route path="/resources/:resourceName" element={<RequireActive><ResourceDetail /></RequireActive>} />
            <Route path="/job-boards" element={<RequireActive><JobBoards /></RequireActive>} />
            <Route path="/favorites" element={<RequireActive><Favorites /></RequireActive>} />
            <Route path="/settings" element={<RequireActive><Settings /></RequireActive>} />
            <Route path="/admin/logos" element={<RequireActive><AdminLogos /></RequireActive>} />
            <Route path="/admin/tools" element={<RequireActive><AdminTools /></RequireActive>} />
            <Route path="/admin/tools-cleaner" element={<RequireActive><AdminToolsCleaner /></RequireActive>} />
            <Route path="/admin/job-boards" element={<RequireActive><AdminJobBoards /></RequireActive>} />
            <Route path="/unlock" element={<Unlock />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/update-password" element={<UpdatePassword />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
